import { StackedMessageLevel } from '../level';

export const severity: Record<StackedMessageLevel, number> = {
  info: 0,
  warning: 1,
  error: 2,
};
